export default "__VITE_ASSET__Dlz$cm2V__";